<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.11 19.9975H1.88875C1.39772 19.9975 1 19.5998 1 19.1088V4.88875C1 4.39772 1.39772 4 1.88875 4H8.11V19.9975Z" fill="#01209F"/>
<path d="M22.33 19.1088C22.33 19.5998 21.9323 19.9975 21.4413 19.9975H15.22V4H21.4413C21.9323 4 22.33 4.39772 22.33 4.88875V19.1088Z" fill="#EF4234"/>
<path d="M15.22 4H8.11V19.9975H15.22V4Z" fill="#E6E6E6"/>
</svg>
